import React, { useState, useEffect } from 'react';
import { callAPI } from "../../../utils/API";
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';

interface PriceTierSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  name?: string;
  label?: string;
  error?: boolean;
  helperText?: string;
}

const PriceTierSelect: React.FC<PriceTierSelectProps> = (props) => {
  const [options, setOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [shouldReload, setShouldReload] = useState<boolean>(true);

  useEffect(() => {
    if (!shouldReload) return;
    setShouldReload(false);
    callAPI("tables/price_tiers", "POST", {
      order: "name ASC"
    })
      .then((res) => {
        setOptions(res.map((price_tier: any) => ({
          value: price_tier.name,
          label: price_tier.name,
        })));
        setLoading(false);
        if (!props.value && res.length > 0) {
          props.onChange(res[0].name);
        }
      })
      .catch((data) => {
        console.log(data);
      });
  }, [props, shouldReload]);

  return (
    <FormControl disabled={props.disabled} fullWidth error={props.error}>
      <InputLabel>{props.label}</InputLabel>
      <Select
        label={props.label}
        value={props.value}
        onChange={(e) => {
          props.onChange(e.target.value as string);
        }}
        name={props.name}
      >
        {loading ? (
          <MenuItem disabled>Loading...</MenuItem>
        ) : (
          options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))
        )}
      </Select>
      {props.helperText ? <FormHelperText>{props.helperText}</FormHelperText> : null}
    </FormControl>
  );
}

export default PriceTierSelect;